// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfe from '../../../form_exportacao_nfe/campos_nfe/selecao_todos_nfe';
import { Input } from '../../../../../../../common/input';

export default function CamposCofinsSt() {
  return (
      <FormSection name="dadosCofinsSt">
        <SelecaoTodosNfe nomes={ ["dadosCofinsSt"] } titulo="Dados da COFINS ST"/>

        <div className="grupo-checkbox">
          <Input name="valorBcCofinsSt" label="Base Cálculo COFINS" checkbox/>
          <Input name="aliquotaPercCofinsSt" label="Alíquota em Percentual" checkbox/>
          <Input name="qtdVendidaCofinsSt" label="Quantidade Vendida" checkbox/>
          <Input name="aliquotaReaisCofinsSt" label="Alíquota em Reais" checkbox/>
          <Input name="valorCofinsSt" label="Valor da COFINS ST" checkbox/>
        </div>
      </FormSection>
  );
}